import { render, staticRenderFns } from "./ApproachFlowForm.vue?vue&type=template&id=6ca0b9ec&scoped=true"
import script from "./ApproachFlowForm.vue?vue&type=script&lang=js"
export * from "./ApproachFlowForm.vue?vue&type=script&lang=js"
import style0 from "./ApproachFlowForm.vue?vue&type=style&index=0&id=6ca0b9ec&prod&lang=scss"
import style1 from "./ApproachFlowForm.vue?vue&type=style&index=1&id=6ca0b9ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca0b9ec",
  null
  
)

export default component.exports